<template lang="pug">
#counter.center
  p.Montserrat(style="font-size:70%") TODAY’S LOVE AND HATE SCORE AROUND THE WORLD
  .row.valign-wrapper#counterMain
    .col.s5
      p.Montserrat.smallestSize.rightT#love LOVE {{loveCount}}
    .col.s2
      img.loveMeter(src="../assets/love.png" v-bind:style="meterStyle")
    .col.s5
      p.Montserrat.smallestSize.leftT#hate HATE {{hateCount}}
  .row.smallSize.Montserrat#tweets
    .col.s1
    .col.s4.tweet(v-if="love.text")
      p.rightT
        b(style="color:white") {{love.user.name	}}
        |  @{{love.user.screen_name	}}
      p.rightT {{love.text}}
    .col.s2
      p <br><br><br><br><br>
    .col.s4.tweet(v-if="hate.text")
      p.leftT
        b(style="color:white") {{hate.user.name	}}
        |  @{{hate.user.screen_name	}}
      p.leftT {{hate.text}}
</template>

<script>
var baseUrl = window.location.hostname == "localhost" ? "http://localhost:5500" : "https://loversnothaters.com";
var socket = undefined;

export default {
  data(){
    return {
      love: {},
      hate: {},
      loveCount: 0,
      hateCount: 0,
      lovePercent: 0,
      loveTime: 0,
      hateTime: 0,
      meterStyle:{
        background: ""
      }
    }
  },
  mounted(){
    socket = io.connect(baseUrl);
    socket.on('love',  (data)=> {
      try{
        var d = new Date();
        if(d.getTime() - this.loveTime > 5000){
          if(!data.tweet || data.tweet.limit || !data.tweet.user.profile_image_url) return 0;
          //console.log(JSON.stringify(data.tweet));
          this.love = data.tweet;
          this.loveTime = d.getTime();
        }
        this.loveCount = data.count;
      }catch(err){
        console.log(err);
        console.log(data);
      }
    });
    socket.on('hate',  (data)=> {
      try{
        var d = new Date();
        if(d.getTime() - this.hateTime > 5000){
          if(!data.tweet || data.tweet.limit || !data.tweet.user.profile_image_url) return 0;
          this.hate = data.tweet;
          this.hateTime = d.getTime();
        }
        this.hateCount = data.count;
      }catch(err){
        console.log(err);
      }
    });
  },
  beforeUpdate(){
    var per = this.loveCount / (this.loveCount + this.hateCount) * 100;
    this.meterStyle.background = "-webkit-linear-gradient(-90deg, #00ffff 0%, #00ffff " + Math.floor(per) + "%, #AAA " + Math.floor(per) + "%, #AAA 100%)";
  }
}
</script>

<style lang="sass" scoped>
#counter
  font-size: 2vw
  width: 100vw
  background-color: black
  margin: 0px
  color: white
  padding-top: 20px
  margin-top: -2px
  p
    margin: 0
    line-height: 1.4
  .loveMeter
    width: 50%
  #counterMain
    padding-top: 10px
    font-weight: 200
  #love
    font-size: 110%
    font-weight: 300
    color: #00ffff
  #hate
    font-size: 110%
    font-weight: 300
    color: rgb(153,153,153)
  #tweets
    font-size: 60%
    font-weight: 400
    color: #CCCCCC
    margin-bottom: 0
  .tweet
    position: relative
    top: -30px
.leftT
  position: relative
  text-align: left
  left: -2.5vw
.rightT
  position: relative
  text-align: right
  right: -2.5vw
</style>



// WEBPACK FOOTER //
// src/components/counter.vue